export interface ToastOptions {
  title: string;
  description?: string;
  duration?: number;
}

export class BadgeToaster {
  private readonly host: HTMLElement;
  private readonly doc: Document;

  constructor(host: HTMLElement, doc?: Document) {
    this.host = host;
    this.doc = doc ?? host.ownerDocument ?? document;
  }

  show(options: ToastOptions): void {
    const toast = this.doc.createElement('article');
    toast.className = 'badge-toast';

    const title = this.doc.createElement('h2');
    title.className = 'badge-toast__title';
    title.textContent = options.title;
    toast.append(title);

    if (options.description) {
      const description = this.doc.createElement('p');
      description.className = 'badge-toast__body';
      description.textContent = options.description;
      toast.append(description);
    }

    this.host.append(toast);
    while (this.host.childElementCount > 4) {
      const first = this.host.firstElementChild;
      if (first) {
        first.remove();
      } else {
        break;
      }
    }

    const duration = options.duration ?? 2800;
    globalThis.setTimeout(() => {
      toast.classList.add('badge-toast--leaving');
      const handle = () => toast.remove();
      toast.addEventListener('animationend', handle, { once: true });
    }, duration);
  }
}
